"use strict";

exports.__esModule = true;
exports.default = void 0;
var theme = {
  // typography
  fontFamily: "'Inter', sans-serif",
  // colors
  textLight: '#fefefe',
  textDark: '#424242',
  primaryColor: '#44C7F4',
  accentColor: '#00F68E',
  grayColor: '#e3e5e7',
  darkColor: '#152F3F',
  successColor: '#0cd895',
  warningColor: '#f0cc00',
  alertColor: '#d9534f'
};
var _default = theme;
exports.default = _default;